import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { AuthContext } from "./lib/AuthContext";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
import firebase from "./lib/firebase";
import Login from "./screens/Login";
import * as serviceWorker from "./serviceWorker";
import Chatrooms from "./screens/Chatrooms";
import ChatroomsAdd from "./screens/Chatrooms/add";
import ChatroomEdit from "./screens/Chatrooms/edit";
import Layout from "./screens/Layout";
import Notfound from "./screens/NotFound";
import Academics from "./screens/Academics";
import AcademicsIndividual from "./screens/Academics/individual";
import AcademicsAdd from "./screens/Academics/add";
import Feminine from "./screens/Feminine";
import FeminineNewsEdit from "./screens/Feminine/News/edit";
import FeminineNewsAdd from "./screens/Feminine/News/add";
import FeminineTrainingAdd from "./screens/Feminine/Training/add";
import FeminineTrainingEdit from "./screens/Feminine/Training/edit";
import FeminineVideosAdd from "./screens/Feminine/Videos/add";
import FeminineVideosEdit from "./screens/Feminine/Videos/edit";
import EgyptianVar from "./screens/EgyptianVar";
import EgyptianVarAdd from "./screens/EgyptianVar/add";
import EgyptianVarEdit from "./screens/EgyptianVar/edit";
import EgyptianAward from "./screens/EgyptianAwards";
import EgyptianAwardsEdit from "./screens/EgyptianAwards/edit";
import EgyptianAwardsAdd from "./screens/EgyptianAwards/add";
import Clubs from "./screens/Clubs";
import ClubsAdd from "./screens/Clubs/add";
import ClubsEdit from "./screens/Clubs/edit";
import ClubsPlayerAdd from "./screens/Clubs/Player/add";
import ClubsPlayerEdit from "./screens/Clubs/Player/edit";
import Social from "./screens/Social";
import SlideShow from "./screens/Slideshow";
import SlideshowAdd from "./screens/Slideshow/add";
import SlideshowEdit from "./screens/Slideshow/edit";
import Users from "./screens/Users";
import MyHobby from "./screens/MyHobby";
import MyHobbyEdit from "./screens/MyHobby/edit";
import EgyptianCoach from "./screens/EgyptianCoach";
import EgyptianCoachExpectationsAdd from "./screens/EgyptianCoach/Expectations/add";
import EgyptianCoachExpectationsEdit from "./screens/EgyptianCoach/Expectations/edit";
import FormationComments from "./screens/Clubs/Formations/comments";
import DeleteAccount from "./screens/DeleteAccount";

const PrivateRoute = ({ user, ...props }) => {
  if (user) {
    return (
      <Layout {...props}>
        <Route {...props} />
      </Layout>
    );
  } else {
    return <Redirect to="/login" />;
  }
};

function App() {
  const [authDetails, setAuthDetails] = useState({ loaded: false, user: null });

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        let adminRef = firebase.database().ref("admin_users/").once("value");
        let userRef = firebase
          .database()
          .ref("users/" + user.uid)
          .once("value");
        Promise.all([adminRef, userRef])
          .then((resArr) => {
            let adminVal = resArr[0].val();
            let userVal = resArr[1].val();
            if (userVal && adminVal && adminVal[user.uid]) {
              authDetails.loaded = true;
              authDetails.user = userVal;
              setAuthDetails({ ...authDetails });
            } else {
              throw new Error("User is not admin");
            }
          })
          .catch((error) => {
            authDetails.loaded = true;
            authDetails.user = null;
            setAuthDetails({ ...authDetails });
          });
      } else {
        authDetails.loaded = true;
        authDetails.user = null;
        setAuthDetails({ ...authDetails });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getRoutes() {
    return (
      <AuthContext.Provider value={authDetails}>
        <Router>
          <div className="h-100">
            <Switch>
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/"
                component={Chatrooms}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/chatroom"
                component={Chatrooms}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/chatroom/add"
                component={ChatroomsAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/chatroom/:key"
                component={ChatroomEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/academics"
                component={Academics}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/academics/add"
                component={AcademicsAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/academics/:key"
                component={AcademicsIndividual}
              />

              <PrivateRoute
                user={authDetails.user}
                exact
                path="/feminine"
                component={Feminine}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/feminine/news/add"
                component={FeminineNewsAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/feminine/news/:key"
                component={FeminineNewsEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/feminine/training/add"
                component={FeminineTrainingAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/feminine/training/:key"
                component={FeminineTrainingEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/feminine/videos/add"
                component={FeminineVideosAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/feminine/videos/:key"
                component={FeminineVideosEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/feminine/:key"
                component={Feminine}
              />

              <PrivateRoute
                user={authDetails.user}
                exact
                path="/coach"
                component={EgyptianCoach}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/coach/expectations/add"
                component={EgyptianCoachExpectationsAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/coach/expectations/:key"
                component={EgyptianCoachExpectationsEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/coach/:key"
                component={EgyptianCoach}
              />

              <PrivateRoute
                user={authDetails.user}
                exact
                path="/var"
                component={EgyptianVar}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/var/add"
                component={EgyptianVarAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/var/:key"
                component={EgyptianVarEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/awards"
                component={EgyptianAward}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/awards/add"
                component={EgyptianAwardsAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/awards/:key"
                component={EgyptianAwardsEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/clubs"
                component={Clubs}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/clubs/add"
                component={ClubsAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/clubs/addplayer/:key"
                component={ClubsPlayerAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/clubs/editplayer/:key/:player"
                component={ClubsPlayerEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/clubs/formations/:clubkey/:key"
                component={FormationComments}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/clubs/:key"
                component={ClubsEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/settings"
                component={Social}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/slideshow"
                component={SlideShow}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/slideshow/add"
                component={SlideshowAdd}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/slideshow/:key"
                component={SlideshowEdit}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/users"
                component={Users}
              />
              <PrivateRoute
                user={authDetails.user}
                exact
                path="/my-hobby"
                component={MyHobby}
              />
              <PrivateRoute
                user={authDetails.user}
                path="/my-hobby/:key"
                component={MyHobbyEdit}
              />
              <Route exact path="/login" component={Login} />
              <Route exact path="/404" component={Notfound} />
              <Route exact path="/delete-account" component={DeleteAccount} />
              <Route component={Notfound} />
            </Switch>
          </div>
        </Router>
      </AuthContext.Provider>
    );
  }

  function getLoading() {
    return <div />;
  }

  if (!authDetails.loaded) {
    return getLoading();
  } else {
    return getRoutes();
  }
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
